import * as Event from '../tools/Event';
import { MQ } from '../tools/MQ';
import { scrollTo } from '../tools/utils';


export const init = () => {
	const TAB_SELECTOR = '[role="tab"]';
	const TABLIST_SELECTOR = '[role="tablist"]';
	const CONTROLS_ATTR = 'aria-controls';
	const SELECTED_ATTR = 'aria-selected';
	const HIDDEN_ATTR = 'aria-hidden';
	const hash = window.location.hash;
	let initialPanel = null;

	if (hash && hash !== '#') {
		initialPanel = document.querySelector(hash);
	}

	const changeHashWithoutJump = (hash) => {
		if (history.pushState) {
			history.pushState(null, null, `#${hash}`);
		} else {
			window.location.hash = hash;
		}
	};

	const setTabSelected = (tab, state) => {
		if (!tab) {
			return;
		}

		if (state) {
			tab.setAttribute(SELECTED_ATTR, state);
		} else {
			tab.removeAttribute(SELECTED_ATTR);
		}
	};

	const setPanelVisible = (panel, state) => {
		if (!panel) {
			return;
		}

		if (state) {
			panel.removeAttribute(HIDDEN_ATTR);
		} else {
			panel.setAttribute(HIDDEN_ATTR, true);
		}
	};

	const getTab = (panel) => document.querySelector(`[${CONTROLS_ATTR}='${panel.getAttribute('id')}']`);

	const getSiblingTabs = (tab) => [...tab.closest(TABLIST_SELECTOR).querySelectorAll(TAB_SELECTOR)];

	const getPanel = (tab) => document.querySelector(`#${tab.getAttribute(CONTROLS_ATTR)}`);

	const getSiblingPanels = (tabs) => [...tabs].map(getPanel);

	const changeTab = (tab) => {
		const tabs = getSiblingTabs(tab);
		const panel = getPanel(tab);
		const panels = getSiblingPanels(tabs);
		const hash = panel.getAttribute('id');

		tabs.forEach((tab) => setTabSelected(tab, false));
		panels.forEach((panel) => setPanelVisible(panel, false));

		setTabSelected(tab, true);
		setPanelVisible(panel, true);
		changeHashWithoutJump(hash);
	};

	const setPanelInitial = (panel) => {
		const tab = getTab(panel);
		const isMobile = MQ('tabletMax');

		changeTab(tab);

		scrollTo(panel, isMobile)
			.then(() => panel.focus());
	};

	const onTabClick = (event) => {
		event.preventDefault();

		const tab = event.target.closest(TAB_SELECTOR);
		const panel = getPanel(tab);
		const isMobile = MQ('tabletMax');
		const profileNav = tab.closest('.b-profile__nav.is-fixed');

		changeTab(tab);

		if (panel.getBoundingClientRect().top < 0 || profileNav) {
			scrollTo(panel, isMobile)
				.then(() => panel.focus());
		}
	};

	const onHashChange = () => {
		const hash = window.location.hash;
		const tablists = [...document.querySelectorAll(TABLIST_SELECTOR)];
		let tabs = [];

		tablists.forEach((tablist) => {
			tabs.push(tablist.querySelector(TAB_SELECTOR));
		});

		if (hash !== '') {
			tabs = [document.querySelector(`${TAB_SELECTOR}[href="${hash}"]`)];
		}

		tabs.forEach(changeTab);
	};


	if (initialPanel && initialPanel.getAttribute('role') === 'tabpanel') {
		setPanelInitial(initialPanel);
	}

	Event.on(document, 'click', onTabClick, TAB_SELECTOR);
	Event.on(window, 'hashchange', onHashChange);
};



// WEBPACK FOOTER //
// ./src/js/components/tabs.js